import Vue from 'vue'
import {en, es, ptBR} from 'vuejs-datepicker/dist/locale'

/**
 * Em Espanhol temos algumas particulariades, como:
 * - trilhão é "billón" ([referência](https://www.wordreference.com/es/en/translation.asp?spen=billon));
 * - bilhão é "mil millones" ([referência](https://www.guiapraticodeespanhol.com.br/2011/10/millon-mil-millones-billon.html?m=1));
 * - milhão é "millón", porém.
 */
const MONETARY_SYMBOLS = {
  in: ['', 'k', 'm', 'bn', 'tn'],
  pt: ['', 'k', 'm', 'bi', 'tri'],
  es: ['', 'k', 'm', 'mm', 'bn']
}

export default {
  changeLanguage: function (idioma) {
    if (idioma) {
      if (idioma.match(/^pt/i)) {
        idioma = 'pt'
      } else if (idioma.match(/^(en|in)/i)) {
        idioma = 'in'
      } else if (idioma.match(/^es/i)) {
        idioma = 'es'
      }
      setCookie(idioma)
    } else {
      idioma = this.getCookieByName('language')
    }
    Vue.i18n.set(idioma)
  },

  getCookieByName: function (cookiename) {
    var cookiestring = RegExp('' + cookiename + '[^;]+').exec(document.cookie)
    if (!cookiestring) {
      return undefined
    } else {
      return unescape(cookiestring.toString().replace(/^[^=]+./, ''))
    }
  },

  getDatePickerLanguage: function () {
    let idioma = this.getCookieByName('language')
    if (idioma) {
      if (idioma.match(/^pt/i)) {
        idioma = 'pt-br'
      } else if (idioma.match(/^(en|in)/i)) {
        idioma = 'en'
      } else if (idioma.match(/^es/i)) {
        idioma = 'es'
      }
    } else {
      idioma = 'pt-br'
    }
    return idioma
  },

  getDatePickerLanguageObject: function () {
    let idioma = this.getCookieByName('language')
    switch (idioma) {
      case 'in':
        idioma = en
        break
      case 'es':
        idioma = es
        break
      default:
        idioma = ptBR
    }
    return idioma
  },

  setLanguageEmulatedLogin: function (language) {
    let idioma = 'pt'
    switch (language) {
      case 'pt_BR':
        idioma = 'pt'
        break
      case 'en_US':
        idioma = 'in'
        break
      case 'es_ES':
        idioma = 'es'
        break
      default:
        idioma = 'pt'
    }
    setCookie(idioma)
    Vue.i18n.set(idioma)
  },

  getMoneyMaskByLanguage: function () {
    let language = this.getCookieByName('language')
    let moneyMask = {}

    switch (language) {
      case 'es':
        moneyMask = {
          decimal: '.',
          thousands: ',',
          prefix: '$ ',
          precision: 2,
          masked: true,
          allowBlank: true
        }
        break
      case 'in':
        moneyMask = {
          decimal: '.',
          thousands: ',',
          prefix: '$ ',
          precision: 2,
          masked: true,
          allowBlank: true
        }
        break
      default:
        moneyMask = {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          precision: 2,
          masked: true,
          allowBlank: true
        }
    }
    return moneyMask
  },

  getMonetaryAbbreviation: function (value, language) {
    language = language || this.getCookieByName('language')
    const symbols = MONETARY_SYMBOLS[language]

    const index = Math.floor((value.toString().length - 1) / 3)
    return symbols[index]
  },

  getIntlCurrencyFormatter: function (minimumFractionDigits = 2, maximumFractionDigits = 2) {
    const language = this.getCookieByName('language')
    let config
    switch (language) {
      // TODO: setar nos cookies o país original para poder definir o locale e a moeda.
      default:
        config = {
          locale: 'pt-BR',
          options: {
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits,
            maximumFractionDigits
          }
        }
        break
    }
    return new Intl.NumberFormat(config.locale, config.options).format
  }
}

function setCookie (idioma) {
  if (idioma) {
    Vue.cookie.set('language', idioma)
  } else {
    Vue.cookie.set('language', 'pt')
  }
}



// WEBPACK FOOTER //
// ./build/language/index.js